import generateColorData from "../../helpers/generateColorData";
import { ColorScale } from "../../types";

const greyA: ColorScale<"greyA"> = {
  greyA1: {
    name: "greyA1",
    data: generateColorData("greyA1", { h: 291, s: 24, l: 6, a: 0.9 }),
  },
  greyA2: {
    name: "greyA2",
    data: generateColorData("greyA2", { h: 291, s: 14, l: 9, a: 0.8 }),
  },
  greyA3: {
    name: "greyA3",
    data: generateColorData("greyA3", { h: 291, s: 4, l: 13, a: 0.65 }),
  },
  greyA4: {
    name: "greyA4",
    data: generateColorData("greyA4", { h: 291, s: 7, l: 15, a: 0.65 }),
  },
  greyA5: {
    name: "greyA5",
    data: generateColorData("greyA5", { h: 291, s: 5, l: 18, a: 0.65 }),
  },
  greyA6: {
    name: "greyA6",
    data: generateColorData("greyA6", { h: 291, s: 5, l: 22, a: 0.65 }),
  },
  greyA7: {
    name: "greyA7",
    data: generateColorData("greyA7", { h: 291, s: 4, l: 28, a: 0.65 }),
  },
  greyA8: {
    name: "greyA8",
    data: generateColorData("greyA8", { h: 291, s: 4, l: 36, a: 0.65 }),
  },
  greyA9: {
    name: "greyA9",
    data: generateColorData("greyA9", { h: 291, s: 4, l: 39, a: 0.65 }),
  },
  greyA10: {
    name: "greyA10",
    data: generateColorData("greyA10", { h: 291, s: 8, l: 50, a: 0.65 }),
  },
  greyA11: {
    name: "greyA11",
    data: generateColorData("greyA11", { h: 291, s: 19, l: 84, a: 0.85 }),
  },
  greyA12: {
    name: "greyA12",
    data: generateColorData("greyA12", { h: 291, s: 14, l: 93, a: 1 }),
  },
  greyA13: {
    name: "greyA13",
    data: generateColorData("greyA13", { h: 291, s: 5, l: 100, a: 0.95 }),
  },
  greyA14: {
    name: "greyA14",
    data: generateColorData("greyA14", { h: 291, s: 4, l: 88, a: 0.95 }),
  },
};

export default greyA;
